
export const fetchSteperData = steperData => ({
    type: 'FETCH_STEPER_DATA',
    payload: { steperData }
})


